<script lang="ts" setup>
import { ref } from 'vue';
import { $fetch } from '@/home/plugins/fetch';
import InfoCard from '@/home/components/InfoCard.vue';
import PeopleCard from '@/home/components/PeopleCard.vue';
import NumberCard from './NumberCard.vue';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: tocMentor } = useAsyncData('about:tocMentor', () => $fetch('/committee/member/v1/list', { data: { committeeType: 4 } }));

const lookMore = ref(false);
</script>

<template>
  <div class="about-technical-oversight-commitee-mentor container mt-32px pb-48px">
    <InfoCard class="structure-box" title-class="min-w-178" :title="$t('about.technicalOversightCommitee.mentor.title')">
      <p class="m-0 text-16px leading-24px">{{ $t('about.technicalOversightCommitee.mentor.description') }}</p>
      <ul class="mx-0 mb-0 mt-16px flex flex-wrap list-none gap-y-32 p-0">
        <li class="w-25% <md:w-full">
          <NumberCard number="1">{{ $t('about.technicalOversightCommitee.mentor.duty1') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="2">{{ $t('about.technicalOversightCommitee.mentor.duty2') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="3">{{ $t('about.technicalOversightCommitee.mentor.duty3') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="4">{{ $t('about.technicalOversightCommitee.mentor.duty4') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="5">{{ $t('about.technicalOversightCommitee.mentor.duty5') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="6">{{ $t('about.technicalOversightCommitee.mentor.duty6') }}</NumberCard>
        </li>
        <li class="w-25% <md:w-full">
          <NumberCard number="7" class="tracking--1.1px">{{ $t('about.technicalOversightCommitee.mentor.duty7') }}</NumberCard>
        </li>
      </ul>
    </InfoCard>

    <div class="mt-48 flex items-center justify-center text-16 text-brand-primary font-normal" v-if="!lookMore">
      <div class="flex cursor-pointer items-center" @click="lookMore = true">
        <span>{{ $t('about.technicalOversightCommitee.mentor.more') }}</span>
        <span class="i-home-icons:arrow-down"></span>
      </div>
    </div>

    <ul class="directors mx-0 mb-0 mt-48px flex flex-wrap list-none p-0 <md:gap-y-24" v-else>
      <li class="w-223px flex-shrink-0 <2xl:w-222px <md:w-full <md:px-20" v-for="item in tocMentor" :key="item.id">
        <PeopleCard responsive :name="item.name" :position="$t('about.technicalOversightCommitee.mentor.position')" :photo="item.photo" :intro="item.intro" :resume="item.resume" />
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.about-technical-oversight-commitee-mentor {
  .directors {
    li {
      + li {
        @apply ml-56px <2xl:ml-22px <md:ml-0;
      }

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 48px;
      }
    }

    @media (max-width: 767.9px) {
      li:nth-child(n + 3) {
        margin-top: 0;
      }
    }
  }
}
</style>
